import React, { Component } from "react";
import classNames from "classnames";
import { Trans } from "react-i18next";
import { Fa } from "composants/Icon";

type PanierProps = {
  loading: boolean;
  children: React.ReactNode;
  disabled: boolean;
  onClear(): void;
  onValidate(): void;
};

export class Panier extends Component<PanierProps> {
  render() {
    const { loading, children, disabled, onClear, onValidate } = this.props;
    return (
      <div className="panel">
        <div className="panel-heading">
          <Trans i18nKey="lov:lov_votre_selection">Votre sélection</Trans>
          <button className="button is-small is-text is-pulled-right" onClick={onClear}>
            <Trans i18nKey="lov:lov_vider">vider</Trans>
          </button>
        </div>
        {children}
        <div className="panel-block">
          <button
            className={classNames("button is-link is-fullwidth", {
              "is-loading": loading
            })}
            onClick={onValidate}
            disabled={disabled}
          >
            <Trans i18nKey="commun_valider">Valider</Trans>
          </button>
        </div>
      </div>
    );
  }
}

interface PanierItemProps {
  title: string;
  removeRow(): void;
}
export const PanierItem: React.FC<PanierItemProps> = ({ title, removeRow }: PanierItemProps) => {
  return (
    <div className="panel-block background-light-grey" style={{ zIndex: 41, cursor: "grab" }}>
      <div className="columns is-paddingless" style={{ width: "100%" }}>
        <div className="column is-11 has-text-weight-semibold">{title}</div>
        <div className="column">
          <a onClick={removeRow}>
            <span className="icon is-small">
              <Fa icon="times" />
            </span>
          </a>
        </div>
      </div>
    </div>
  );
};
